import VideoTimelineClipSplitIcon from '@atlaskit/icon-lab/core/video-timeline-clip-split';
import * as React from 'react';

export function SvgSplit() {
  return <VideoTimelineClipSplitIcon label="" testId="ads-refreshed-icon" />;
}
